import moment from "moment";
import { watch } from "@vue/composition-api";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";

export function hsabBankBalanceWatch () {
    const hsabInvestmentStore = useHsabInvestmentStore();
    const investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
    watch(() => hsabInvestmentStore.hsabInvestmentBalance, newValue => {
        investmentDailyBalanceStore.setHsaBankBalance({
            balance: newValue,
            date: moment().format("YYYY-MM-DD")
        });
    });
}